import { History, Location } from 'history';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { loginUrl } from 'mk2/apps/users/urls';
import { makeAbsoluteUrl, url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import { redirectInPWA } from 'mk2/services/browserHistory';
import React from 'react';

// every component where @authOnly() decorator is applied must contain these attributes
interface AuthOnlyProps {
    requestUser: UserEntity;
    history: History;
    location: Location;
}

/**
 * Decorator enforcing that request user is authenticated. Otherwise it redirects to login page.
 *
 * Used on React.Component e.g.
 *
 * @authOnly()
 * class MyComponent extends React.Component {
 *     ...
 * }
 *
 * @returns decorator
 */
// tslint:disable-next-line:ban-types
export function authOnly(): <P, C extends Function>(WrappedComponent: C & React.ComponentClass<P & AuthOnlyProps>) => C {
    return (WrappedComponent) => {
        class AuthOnlyHoC extends React.Component<AuthOnlyProps> {
            public componentWillMount() {
                const { history, location, requestUser } = this.props;

                // check before mounting, so that we redir only once (not on each re-render)
                if (!isAuthenticated(requestUser)) {
                    const gotoUrl = url(loginUrl, {},  {next: `${location.pathname}${location.search}`});
                    redirectInPWA(history, gotoUrl, 401);
                }
            }

            public render() {
                return isAuthenticated(this.props.requestUser) ? <WrappedComponent {...this.props as any} /> : null;
            }
        }
        return AuthOnlyHoC as any;
    };
}
